import * as tslib_1 from "tslib";
import confirmItemActionAllowed from '../utils/confirmItemActionAllowed';
import getLatestNonDraftItemIdFromConversation from '../utils/getLatestNonDraftItemIdFromConversation';
import { onPrintRow } from 'owa-mail-module-orchestrator';
import { lazyPrint, readingPaneStore } from 'owa-mail-reading-pane-store';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { action } from 'satcheljs/lib/legacy';
export default action('printConversation')(function printConversation(conversationId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var latestNonDraftItemId, restrictionToConfirm;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getLatestNonDraftItemIdFromConversation(conversationId)];
                case 1:
                    latestNonDraftItemId = _a.sent();
                    if (latestNonDraftItemId && latestNonDraftItemId.Id) {
                        restrictionToConfirm = { PrintAllowed: true };
                        if (confirmItemActionAllowed(latestNonDraftItemId.Id, restrictionToConfirm, format(strings.irm_actionNotAllowedOnThisConversation, strings.itemHeaderPrint))) {
                            lazyPrint.importAndExecute(latestNonDraftItemId, function (viewState) {
                                readingPaneStore.itemPrintPaneViewState = viewState;
                            } /* Store the viewState as the item print pane viewState in the RP store */);
                            onPrintRow();
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=printConversation.js.map